import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import {createLesson} from '../../redux/slices/builder';
import {selectUserGroup} from '../../redux/slices/user';
import {FEATURES} from '../../constants';

import baseStyles from '../../css/Base.module.css';

export default function CreateLessonDialog({isOpen, handleClose}) {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const [name, setName] = useState('');
  const [visibility, setVisibility] = useState('');
  const [isSaving, toggleIsSaving] = useState(false);

  const userGroup = useSelector(selectUserGroup);
  const {tier: {features}} = userGroup;
  const visibilityFeatures = features.filter((feature) => feature.startsWith('VISIBILITY_'));

  useEffect(() => {
    setVisibility(getDefaultVisibility());
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  function resetState() {
    setName('');
    setVisibility('');
    toggleIsSaving(false);
  }

  function getDefaultVisibility() {
    // Auto set visibility when only one option is available
    if (visibilityFeatures.length === 1) {
      if (visibilityFeatures[0] === FEATURES.VISIBILITY_PRIVATE) return 'PRIVATE';
      if (visibilityFeatures[0] === FEATURES.VISIBILITY_USER_GROUP) return 'USER_GROUP';
      if (visibilityFeatures[0] === FEATURES.VISIBILITY_PUBLIC) return 'PUBLIC';
    }
    return 'PRIVATE'; // Defaults to private when more than one option is available
  }

  function handleNameChanged(event) {
    setName(event.target.value);
  }

  async function handleSave() {
    toggleIsSaving(true);

    const {_id: lessonID} = await dispatch(createLesson(name, visibility));
    history.push(`/builder/lessons/${lessonID}`);
  }

  function isSaveButtonEnabled() {
    return !!name && !!visibility && !isSaving;
  }

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        TransitionProps={{
          onExited: resetState
        }}>
        <DialogTitle>New Lesson</DialogTitle>
        <DialogContent>
          <TextField
            variant="standard"
            margin="dense"
            label="Name"
            onChange={handleNameChanged}
            value={name}
            autoFocus
            required
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button className={baseStyles['btn-pill']} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={baseStyles['btn-pill']}
            onClick={handleSave}
            variant="contained"
            disabled={!isSaveButtonEnabled()}
          >
            {isSaving ? <CircularProgress size={25} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
